const fetchGuides = async (filters) => {
  const filtersString = JSON.stringify(filters);
  const guides = await fetch(inclusionData.ajax, {
    method: "POST",
    body: new URLSearchParams({
      action: "inclusion_load_guides",
      filters: filtersString,
    }),
  });
  return await guides.json();
};

export default fetchGuides;
